import React, { CSSProperties, ReactNode } from 'react'

import styles from '../../Grid.module.scss'

type ResponsiveConfig = {
	span?: number
	order?: number
}

export interface ColProps {
	children?: ReactNode
	span?: number
	order?: number
	xs?: number | ResponsiveConfig
	sm?: number | ResponsiveConfig
	md?: number | ResponsiveConfig
	lg?: number | ResponsiveConfig
	xl?: number | ResponsiveConfig
	xxl?: number | ResponsiveConfig
	hidden?: boolean
	style?: CSSProperties
	className?: string
	_gutter?: [number, number] // оставим для совместимости, но не используем
}

const getResponsiveProps = (props: ColProps): { span?: number; order?: number; classes: string[] } => {
	const { span, order, xs, sm, md, lg, xl, xxl } = props
	const classes: string[] = []

	if (span !== undefined) classes.push(styles[`col-${span}`])
	if (order !== undefined) classes.push(styles[`col-order-${order}`])

	const breakpoints = { xs, sm, md, lg, xl, xxl }

	Object.entries(breakpoints).forEach(([bp, config]) => {
		if (config !== undefined) {
			if (typeof config === 'number') {
				classes.push(styles[`col-${bp}-${config}`])
			} else {
				if (config.span !== undefined) classes.push(styles[`col-${bp}-${config.span}`])
				if (config.order !== undefined) classes.push(styles[`col-${bp}-order-${config.order}`])
			}
		}
	})

	return { classes, span, order }
}

export const Col: React.FC<ColProps> = ({ children, hidden, style, className, _gutter, ...restProps }) => {
	if (hidden) return null

	const { classes } = getResponsiveProps(restProps)

	// Паддинги больше не нужны — gap всё делает сам
	const colStyle: CSSProperties = {
		...style
	}

	const classNames = [styles.col, ...classes, className].filter(Boolean).join(' ')

	return (
		<div className={classNames} style={colStyle}>
			{children}
		</div>
	)
}
